var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* tslint:disable:jsx-no-multiline-js */
import classnames from 'classnames'; // react不支持多个className 该插件可以写多个className
import React from 'react';
import ButtonChild from './ButtonChild';
import Icon from '../icon';
export default class FloatButton extends React.Component {
    // private shadeHeight:number;
    constructor(props) {
        super(props);
        this.isExecuteBtnHidden = false;
        this.contains = (root, n) => {
            let node = n;
            while (node) {
                if (node === root) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        };
        this.buttonClick = () => {
            // e.nativeEvent.stopImmediatePropagation();
            const { childShowStartType, childShowEndType, } = this.props;
            const moveCls = this.state.btnMoveCls;
            this.setState({
                btnMoveCls: (moveCls === '' || moveCls === childShowEndType) ? childShowStartType : childShowEndType,
                iconIsRotateCls: (moveCls === '' || moveCls === childShowEndType) ?
                    `${this.props.prefixCls}-icon-rotate` :
                    `${this.props.prefixCls}-icon-reverse-rotate`,
            });
        };
        this.onClickFatherBtn = (data) => {
            // e.nativeEvent.stopImmediatePropagation();
            this.props.onClick ? this.props.onClick(data) : null;
        };
        this.state = {
            btnMoveCls: '',
            iconIsRotateCls: '',
        };
    }
    componentDidMount() {
        const btnWrapper = document.getElementsByClassName('bs-float-button')[0];
        document.addEventListener('click', (e) => {
            if (!this.contains(btnWrapper, e.target)) {
                if (this.isExecuteBtnHidden) {
                    const { childShowEndType } = this.props;
                    this.setState({
                        btnMoveCls: childShowEndType,
                        iconIsRotateCls: `${this.props.prefixCls}-icon-reverse-rotate`,
                    });
                }
            }
        }, false);
    }
    componentDidUpdate() {
        if (this.state.btnMoveCls === this.props.childShowStartType) {
            this.isExecuteBtnHidden = true;
        }
        else {
            this.isExecuteBtnHidden = false;
        }
    }
    // clickShade(e: React.MouseEvent<HTMLElement>):void {
    //   // e.stopPropagation();
    // }
    render() {
        const _a = this.props, { prefixCls, children, className, style, size, isRotate = true, onClick, direction = "left", type = '', isShowShade = true } = _a, restProps = __rest(_a, ["prefixCls", "children", "className", "style", "size", "isRotate", "onClick", "direction", "type", "isShowShade"]);
        const wrapCls = classnames(prefixCls, className);
        const childNodeLength = children ? children.length : 0;
        const childCls = classnames(`${prefixCls}-child-button`, `${prefixCls}-child-button-length-${childNodeLength}`);
        const transmitProps = {
            direction,
            size,
            childNodeLength
        };
        return (<div className={wrapCls} {...restProps}>
        <div className={`${prefixCls}-wrapper`}>
          <div className={`${prefixCls}-center`} style={{ width: `${size}px`, height: `${size}px` }} onClick={childNodeLength === 0
            ?
                // onClick
                //   ?
                this.onClickFatherBtn.bind(this, { btnStatus: this.state.btnStatus })
            // onClick.bind(this, { btnStatus: this.state.btnStatus })
            // :
            // false
            :
                this.buttonClick}>
            <Icon type={type} className={isRotate ? this.state.iconIsRotateCls : null}></Icon>
            <div className={childCls}>
              {childNodeLength === 0 ? null : childNodeLength > 1 ? children.map((child, index) => {
            return React.cloneElement(child, Object.assign({ nodeIndex: index, key: index, btnMoveCls: this.state.btnMoveCls }, transmitProps));
        }) : React.cloneElement(children, Object.assign({ nodeIndex: 0, key: 0, btnMoveCls: this.state.btnMoveCls }, transmitProps))}
            </div>
          </div>
        </div>
      </div>);
    }
}
FloatButton.ButtonChild = ButtonChild;
FloatButton.defaultProps = {
    prefixCls: 'bs-float-button',
};



// WEBPACK FOOTER //
// ./components/float-button/index.tsx